import { render, staticRenderFns } from "./DialogBody.vue?vue&type=template&id=b8438fca&"
import script from "./DialogBody.vue?vue&type=script&lang=js&"
export * from "./DialogBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports